class Menu {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.classOpen = 'menu--is-open'
        this.run()
    }
    run() {
        document.querySelectorAll('[data-menu]').forEach((el) => this.init(el))
        window.addEventListener('click', () => {
            document.querySelectorAll('[data-menu]').forEach((el) => {
                el.classList.remove(this.classOpen)
            })
        })
    }
    init(elMenu) {
        const elID = elMenu.dataset.menu;
        this.classOpen = elMenu.dataset.menuClass;

        elMenu.addEventListener('click', (ev) => {
            ev.stopPropagation()
        })
        document.querySelector('[data-menu-content]').addEventListener('click', (ev) => {
            ev.stopPropagation()
        })
        document.querySelectorAll('[data-menu-toggle="' + elID + '"]').forEach((el) => this.initAction(el, elMenu, 'toggle'))
        document.querySelectorAll('[data-menu-open="' + elID + '"]').forEach((el) => this.initAction(el, elMenu, 'open'))
        document.querySelectorAll('[data-menu-close="' + elID + '"]').forEach((el) => this.initAction(el, elMenu, 'close'))
    }
    initAction(elAction, elMenu, actionType) {
        elAction.addEventListener('click', (ev) => {
            console.log(this.classOpen, elMenu)
            ev.stopPropagation()
            if ('open' === actionType) {
                elMenu.classList.add(this.classOpen)
            } else if ('close' === actionType) {
                elMenu.classList.remove(this.classOpen)
            } else {
                elMenu.classList.toggle(this.classOpen)
            }
        })
    }
}

export default Menu